import { AsyncPipe, NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
} from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { Asset, Faq, Entry as GQLEntry } from '@generated/graphql';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { RichTextDocumentComponent } from '../../contentful-dynamic/rich-text/rich-text-document/rich-text-document.component';

@Component({
    selector: 'app-faq-contentful-item',
    templateUrl: './faq-contentful-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, RichTextDocumentComponent, AsyncPipe],
    host: { ngSkipHydration: 'true' },
})
export class FaqContentfulItemComponent implements OnInit {
    @Input() faq: Faq;
    open: boolean = false;
    resolvedLinks: Map<string, Asset | GQLEntry>;
    show: Observable<boolean>;
    @Input() additionalClasses: string[];
    constructor(private environmentService: EnvironmentService) {}

    ngOnInit(): void {
        const links = [...(this.faq?.answer?.links.entries.hyperlink || [])];
        this.resolvedLinks = new Map(
            links.filter(item => item?.sys?.id).map(item => [item.sys.id, item])
        );
        const showGraphQLFaq = !!this.faq?.question && !!this.faq?.answer;
        if (this.faq && showGraphQLFaq) {
            if (this.environmentService.isBrowser()) {
                this.show = of(true).pipe(delay(10));
            } else {
                this.show = of(true);
            }
        }
    }

    toggleOpen() {
        this.open = !this.open;
    }
}
